import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const CheckboxContainer = styled.div `
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  opacity: 0;
  transition: opacity 0.175s ease-in-out;

  ${({ $show }) => $show && 'opacity: 1'};
`;
